import { VideosManager } from "@/components/Settings/VideosManager";

export function SettingsVideos() {
  return (
    <div className="space-y-6 p-6">
      <div>
        <h1 className="text-3xl font-bold">Videos</h1>
        <p className="mt-2 text-muted-foreground">
          Add, update, and remove videos shown on the dashboard.
        </p>
      </div>
      <VideosManager />
    </div>
  );
}
